import { useEffect, useRef, useState } from "react";

const CARD_MIN_WIDTH = 260;
const GAP = 16;

export function useStudentGridLayout() {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [cardsPerRow, setCardsPerRow] = useState<number | undefined>(undefined);

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      const containerWidth = entry.contentRect.width;

      const fullCardWidth = CARD_MIN_WIDTH + GAP;
      const count = Math.floor((containerWidth + GAP) / fullCardWidth);

      const valid = count > 0 ? count : 1;
      setCardsPerRow(valid);
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return {
    containerRef,
    cardsPerRow,
  };
}
